import { BrowserRouter, Route, Routes } from "react-router-dom";
import Benefits from "./components/Benefits";
import CTA from "./components/CTA";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import ForgotPasswordVerifyPage from "./pages/ForgotPasswordVerifyPage";
import RegisterPage from "./pages/RegisterPage";
import RegisterVerifyPage from "./pages/RegisterVerifyPage";
import VisitorPage from "./pages/VisitorPages";
import "moment/locale/id";
import HelpPage from "./pages/HelpPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <Features />
    <Benefits />
    <CTA />
    <Footer />
  </>
);
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/bantuan" element={<HelpPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register_verify" element={<RegisterVerifyPage />} />
        <Route
          path="/forgot_password_verify_admin"
          element={<ForgotPasswordVerifyPage />}
        />
        <Route path="/visitor/:qrCode" element={<VisitorPage />} />
        <Route path="/privasi" element={<PrivacyPolicy />} />
        <Route path="/syarat-ketentuan" element={<TermsConditions />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
